module.exports = __webpack_public_path__ + "img/logo.dea11589.png";